import { Plugins } from '@capacitor/core';
import { IonButton, IonContent, IonInput, IonLabel, IonPage, IonToast, isPlatform } from '@ionic/react';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { logar, requestService } from '../../../Utils/Services';
import './Login.css';
import imgTopo from './imgs/LogoCor.png';

const Login: React.FC = () => {
  const { Http } = Plugins;
  const history = useHistory();
  const [telefone, setTelefone] = useState("");
  const [senha, setSenha] = useState("");
  const [cpf, setCPF] = useState("");
  const [primeiroFoco, setPrimeiroFoco] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [botaoAtivo, setBotaoAtivo] = useState(true);
  const [textBotao, setTextBotao] = useState("Continuar");
  const campoCPF = useRef<any>(null);
  const campoTelefone = useRef<any>(null);
  const campoSenha = useRef<any>(null);
  const TAB_KEY_CODE = 9;
  const ENTER_KEY_CODE = 13;

  function onChangeCPF(e: any) {
    setPrimeiroFoco(true);
    e.persist();
    e.preventDefault();

    if (e.keyCode === ENTER_KEY_CODE || e.keyCode === TAB_KEY_CODE) {
      e.target.value = e.target.value.substring(0, 14);
      setCPF(e.target.value.substring(0, 14));
      campoTelefone.current.setFocus();
    }

    if (e.target.value.length > 14) {
      e.target.value = e.target.value.substring(0, 14);
      setCPF(e.target.value.substring(0, 14));
      return;
    }

    let val = e.target.value;
    var cpfval = val.replace(/\D/g, "")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    setCPF(cpfval);
  }

  // function validarCPF(cpf: string): boolean {
  //   cpf = cpf.replace(/\D/g, '');

  //   if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  //   const calcularDigito = (base: number) => {
  //     let soma = 0;
  //     for (let i = 0; i < base; i++) {
  //       soma += parseInt(cpf[i]) * (base + 1 - i);
  //     }
  //     const resto = (soma * 10) % 11;
  //     return resto === 10 ? 0 : resto;
  //   };

  //   return (
  //     calcularDigito(9) === parseInt(cpf[9]) &&
  //     calcularDigito(10) === parseInt(cpf[10])
  //   );
  // }

  function validarCPF(cpf: string): boolean {
    const apenasNumeros = cpf.replace(/\D/g, '');
    return apenasNumeros.length === 11;
  }

  function validarTelefone(telefone: string): boolean {
    const tel = telefone.replace(/\D/g, '');
    return tel.length === 11;
  }

  const logarEvent = () => {
    if (!botaoAtivo) return;

    // Validação de CPF e telefone
    const cpfValido = validarCPF(cpf);
    const telefoneValido = validarTelefone(telefone);
    if (!cpfValido) {
      setTextToast("CPF inválido");
      setShowToast(true);
      return;
    }
    if (!telefoneValido) {
      setTextToast("Telefone inválido");
      setShowToast(true);
      return;
    }

    setBotaoAtivo(false);
    setTextBotao("Aguarde...");

    let usuarioCPF = cpf.replace("-", "").replace(".", "").replace(".", "");

    const objectRequest = {
      telefone: "55" + telefone.replace("(", "").replace(")", "").replace(" ", "").replace("-", ""),
      dispositivoIos: isPlatform('ios')
    }

    requestService(
      logar.url.replace("{cpf}", usuarioCPF),
      {
        method: logar.method,
        headers: [
          ["token", localStorage.getItem("token") || ""]
        ],
        body: JSON.stringify(objectRequest),
      },
      history,
      (response: any) => {
        if (response) {
          window.localStorage.setItem("cpf", usuarioCPF);
          window.localStorage.setItem("token", response.token);
          window.localStorage.setItem("perfil", response.perfil);
          if (typeof response.pinCadastrado !== 'undefined') {
            window.localStorage.setItem("pinCadastrado", String(response.pinCadastrado));
          } else {
            window.localStorage.removeItem("pinCadastrado");
          }

          window.localStorage.setItem("telefone", "55" + telefone.replace(/\(/g, "").replace(/\)/g, "").replace(/\ /g, "").replace(/\-/g, ""));

          if (response.perfil) {
            setCPF("");
            setSenha("");
            setTelefone("");
            setBotaoAtivo(true);
            setTextBotao("Continuar");
            history.push("/validar-otp");
          }
          else {
            history.replace("/empresa/inicio");
          }
        } else if (response.status === 400) {

        }
      },
      (error: any) => {
        setTextToast("Informações inválidas");
        setShowToast(true);
        setBotaoAtivo(true);
        setTextBotao("Continuar");
      }
    )
  }

  function onKeyUpTelefone(e: any) {
    e.persist();
    e.preventDefault();

    if (e.keyCode === ENTER_KEY_CODE) {
      e.target.value = e.target.value.substring(0, 15);
      setTelefone(e.target.value.substring(0, 15));
      logarEvent();
    }

    if (e.target.value.length > 15) {
      e.target.value = e.target.value.substring(0, 15);
      setTelefone(e.target.value.substring(0, 15));
      return;
    }

    let val = e.target.value;
    var telVal = val.replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{4})(\d+?)$/, "$1");
    setTelefone(telVal);
  }

  return (
    <IonPage>
      <IonContent className={"Login"}>
        {/* Background Image */}
        <div className="background-image" style={{ backgroundImage: "url('/assets/fundo.jpg')" }}></div>
        <div className="background-overlay"></div>

        {/* Content Container */}
        <div className="login-container">

          {/* Left Side - Marketing */}
          <div className="marketing-section">
            <h1 className="marketing-title">
              PDV, delivery e gestão em um só lugar.
            </h1>

            <div className="logo-badge">
              <div className="logo-badge-icon">
                <img src={imgTopo} alt="Logo Xeguei" />
              </div>
              <div className="logo-badge-text">
                <p>Ajudando<br />sua<br />empresa<br />a crescer</p>
              </div>
            </div>
          </div>

          {/* Right Side - Login Card */}
          <div className="login-card">
            <div className="card-header">
              <h2 className="card-title">Portal da Empresa</h2>
              <p className="card-subtitle">Gerencie sua empresa de forma fácil e rápida</p>
            </div>

            <div className="input-group">
              <IonLabel className="input-label">CPF</IonLabel>
              <IonInput
                type="tel"
                maxlength={14}
                placeholder="___.___.___-__"
                required
                value={cpf}
                onKeyUp={onChangeCPF}
                onIonInput={(e: any) => setCPF(e.target.value)}
                className="ion-input-field"
              />
            </div>

            <div className="input-group">
              <IonLabel className="input-label">Telefone</IonLabel>
              <IonInput
                ref={(ref) => campoTelefone.current = ref}
                type="tel"
                maxlength={15}
                placeholder="(__) _____-____"
                required
                value={telefone}
                onKeyUp={onKeyUpTelefone}
                onIonInput={(e: any) => setTelefone(e.target.value)}
                className="ion-input-field"
              />
            </div>

            <IonButton
              className="btn-primary"
              expand="block"
              disabled={!botaoAtivo}
              onClick={() => { logarEvent(); }}
            >
              {textBotao}
            </IonButton>

            <IonButton
              className="btn-help"
              expand="block"
              fill="clear"
              onClick={() => {
                window.open("https://api.whatsapp.com/send?phone=5511963927646&text=Estou%20com%20problemas%20para%20acessar%20o%20Xeguei,%20poderiam%20me%20ajudar?", "_blank");


              }}
            >
              Preciso de ajuda para acessar
            </IonButton>

            <div className="divider"></div>

            <div className="signup-section">
              <IonLabel className="signup-text">
                Ainda não tem cadastro?{' '}
                <span
                  className="signup-link"
                  onClick={() => { history.push("/tipoconta"); }}
                >
                  Cadastre sua empresa
                </span>
              </IonLabel>
            </div>
          </div>

          {/* Mobile Logo Badge */}
          {/* <div className="mobile-logo-badge">
            <div className="logo-badge">
              <div className="logo-badge-icon">
                <img src={imgTopo} alt="Logo Xeguei" />
              </div>
              <div className="logo-badge-text">
                <p>Ajudando<br />sua<br />empresa<br />a crescer</p>
              </div>
            </div>
          </div> */}
        </div>

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />
      </IonContent>
    </IonPage>
  );
};

export default Login;